import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { GET_DEAL, DELETE_DEAL, UPDATE_DEAL, ADD_NEW_DEAL } from "./actionType";

import {
  getDealSuccess,
  getDealFail,
  deleteDealSuccess,
  deleteDealFail,
  updateDealSuccess,
  updateDealFail,
  addDealSuccess,
  addDealFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveDealApi,
  getDealApi,
  updateDealApi,
  deleteDealApi,
  addNewDealApi,
} from "../../helpers/backend_helper";

function* getDeal({ payload: deal }) {
  try {
    const response = yield call(getDealApi, deal);
    yield put(getDealSuccess(GET_DEAL, response.data));
  } catch (error) {
    yield put(getDealFail(GET_DEAL, error));
  }
}

function* onUpdateDeal({ payload: deal }) {
  try {
    if (deal.setApprove) {
      const response = yield call(approveDealApi, deal);
      yield put(updateDealSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateDealApi, deal);
      yield put(updateDealSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateDealFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteDeal({ payload: deal }) {
  try {
    const response = yield call(deleteDealApi, deal);
    yield put(deleteDealSuccess({ deal, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteDealFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewDeal({ payload: deal }) {
  try {
    const response = yield call(addNewDealApi, deal);
    yield put(addDealSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addDealFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetDeal() {
  yield takeEvery(GET_DEAL, getDeal);
}

export function* watchUpdateDeal() {
  yield takeEvery(UPDATE_DEAL, onUpdateDeal);
}

export function* watchDeleteDeal() {
  yield takeEvery(DELETE_DEAL, onDeleteDeal);
}

export function* watchAddNewDeal() {
  yield takeEvery(ADD_NEW_DEAL, onAddNewDeal);
}

function* dealSaga() {
  yield all([
    fork(watchGetDeal),
    fork(watchDeleteDeal),
    fork(watchUpdateDeal),
    fork(watchAddNewDeal),
  ]);
}

export default dealSaga;
